module.exports = __webpack_public_path__ + "media/images/pinterest-share-4f40ac37a1597a06c5e17bb063a9e4e5.png";